import React, { ReactType, useContext } from 'react';
import { Container } from 'react-bootstrap';
import { Redirect, Route, RouteProps } from 'react-router';

import Footer from 'src/components/Footer';
// import ContextSwitchingMenu from 'src/containers/ContextSwitchingMenu';
import { AppViewContext } from 'src/containers/Core/AppView';
import { CHOOSE_BUSINESS, SIGN_UP, VERIFY_EMAIL } from 'src/containers/Core/Paths';
import Header from 'src/containers/Header';
import LeftMenu from 'src/containers/LeftMenu';
import { isAuthenticated } from 'src/utils/common';

import style from './style.module.scss';

type OwnProps = {
  header?: boolean;
  footer?: boolean;
  leftMenu?: boolean;
  auth?: boolean;
};

type LayoutProps = {
  component: ReactType;
  render?: ReactType;
} & RouteProps &
  OwnProps;

const Layout: React.FunctionComponent<LayoutProps> = ({
  header,
  footer,
  leftMenu,
  component,
  render,
  auth,
  ...rest
}) => {
  const Component: ReactType = component || render;
  const { isPhoneView } = useContext(AppViewContext);
  const isAuthorizeRoute = () => isAuthenticated() && !location.pathname.includes(VERIFY_EMAIL);

  return (
    <Route
      render={routeProps =>
        isAuthorizeRoute() ? (
          auth ? (
            <div className={`${style.layout} d-flex flex-column`}>
              {leftMenu ? (
                <div className={`d-flex h-100`}>
                  {/* <ContextSwitchingMenu /> */}
                  <LeftMenu />
                  <Container
                    fluid
                    className={`${style.main} p-0 ${isPhoneView ? 'main-container-mobile-view' : 'main-container'}`}
                  >
                    {header && isPhoneView ? <Header /> : null}
                    <Component {...routeProps} />
                  </Container>
                </div>
              ) : null}
              {footer ? <Footer /> : null}
              {!leftMenu ? (
                <Container fluid className={`vh-100 overflow-hidden`}>
                  <Component {...routeProps} />
                </Container>
              ) : null}
            </div>
          ) : (
            <Redirect to={{ pathname: CHOOSE_BUSINESS, state: true }} />
          )
        ) : !auth ? (
          <div className={`${style.layout} d-flex flex-column`}>
            {footer ? <Footer /> : null}
            <Container fluid className={`vh-100 overflow-hidden`}>
              <Component {...routeProps} />
            </Container>
          </div>
        ) : (
          <Redirect to={SIGN_UP} />
        )
      }
      {...rest}
    />
  );
};

Layout.defaultProps = {
  header: true,
  footer: false,
  leftMenu: true,
  auth: true,
};

export default Layout;
